<span class="field-view-value">{{formattedTimezone}}</span>
